import {Injectable} from '@angular/core';
import {BaseService} from '../../../../core/abstracts/base-service.abstract';
import {Updatable} from '../../../../core/interfaces/base-service.interfaces';
import {VehicleResponse} from '../../vehicles/vehicle/model/vehicle-response.model';
import {VehicleAnnotationRequest} from '../model/vehicle-annotation-request.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class VehicleAnnotationService extends BaseService implements Updatable<VehicleAnnotationRequest, VehicleResponse> {

  protected override endpoint: string = 'items';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  update(vehicleId: string, payload: Partial<VehicleAnnotationRequest>): Observable<VehicleResponse> {
    return this.put<VehicleResponse>(`/${vehicleId}/annotations`, payload);
  }
}
